import * as router from 'plugins/router';

declareModules({
  'viewmodels/contacts/payments': () => import('@/legacy/viewmodels/contacts/payments'),
  'views/contacts/payments.html': () => import('@/legacy/views/contacts/payments.html'),
});

export class ViewModel {
  public router: DurandalRouter;

  constructor() {
    this.router = router
      .createChildRouter()
      .makeRelative({
        moduleId: 'viewmodels/contacts',
        fromParent: true,
      })
      .map([{ route: ['mypayments/:id'], title: 'My Payments', moduleId: 'payments', nav: false }])
      .buildNavigationModel();
  }
}
